import React from "react";

// Country name -> flag-icons CSS code. The backend's /transfer-windows/
// countries/ endpoint returns image_url built from the lower-case country
// name, which 404s for non-ISO entities like the British home nations
// (England, Scotland, Wales, Northern Ireland) and other special cases.
// Those have flag-icons codes but no standalone ISO file. This map mirrors
// the backend's _FLAG_CODE_OVERRIDE (country_meta.py) so the rendered flag
// uses the loaded flag-icons CSS class when an override exists, and falls
// back to image_url otherwise.
//
// Shared between the Home dashboard transfer-window widget and the Agent
// Tenders / Requests transfer-window dropdown so both render the SAME clean,
// correctly-mapped flags.
export const FLAG_CODE_OVERRIDE = {
  England: "gb-eng", Scotland: "gb-sct", Wales: "gb-wls", "Northern Ireland": "gb-nir",
  Türkiye: "tr", Turkey: "tr",
  "Republic of Ireland": "ie",
  USA: "us", "United States": "us",
  UAE: "ae", "United Arab Emirates": "ae",
  "Korea Republic": "kr", "South Korea": "kr",
  "Korea DPR": "kp", "North Korea": "kp",
  "China PR": "cn", China: "cn",
  "Cape Verde": "cv", "Cabo Verde": "cv",
  "Congo DR": "cd", "DR Congo": "cd",
  "Ivory Coast": "ci", "Cote d'Ivoire": "ci", "Côte d'Ivoire": "ci",
  "Chinese Taipei": "tw", Taiwan: "tw",
  "Hong Kong": "hk", "Hong Kong, China": "hk",
  Macau: "mo",
  "North Macedonia": "mk",
  Czechia: "cz",
  "Bosnia and Herzegovina": "ba",
  Eswatini: "sz",
  "St Kitts and Nevis": "kn", "Saint Kitts and Nevis": "kn",
  "St Lucia": "lc", "Saint Lucia": "lc",
  "St Vincent and the Grenadines": "vc", "Saint Vincent and the Grenadines": "vc",
  "São Tomé and Príncipe": "st", "Sao Tome and Principe": "st",
  "The Gambia": "gm", Gambia: "gm",
  "Timor-Leste": "tl", "East Timor": "tl",
  "Lao PDR": "la", Laos: "la",
  "Brunei Darussalam": "bn", Brunei: "bn",
  "Kyrgyz Republic": "kg", Kyrgyzstan: "kg",
  "IR Iran": "ir", Iran: "ir",
  "Aotearoa New Zealand": "nz",
};

// Render a country flag - uses the loaded flag-icons CSS class when we have a
// known code for the country (so non-ISO entities like England render their
// own correct flag), otherwise falls back to the backend-supplied image_url,
// otherwise nothing. Size is controlled via width/height so dropdown rows +
// active-row sit aligned. The 3:2 width/height ratio keeps the flag full and
// uncropped at the dropdown's size.
export default function CountryFlag({ country, imageUrl, width = 24, height = 16 }) {
  const code = country ? FLAG_CODE_OVERRIDE[country] : null;
  if (code) {
    return (
      <span
        className={`fi fi-${code} inline-block bg-cover bg-center rounded-sm flex-shrink-0`}
        style={{
          width, height,
          boxShadow: "inset 0 0 0 0.5px rgba(0,0,0,0.08)",
        }}
        role="img"
        aria-label={country}
      />
    );
  }
  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt=""
        className="object-cover flex-shrink-0 rounded-sm"
        style={{
          width, height,
          boxShadow: "inset 0 0 0 0.5px rgba(0,0,0,0.08)",
        }}
      />
    );
  }
  return null;
}
